module.exports = __webpack_public_path__ + "img/4.d192ae9b.jpg";